import { ref, computed } from '@vue/composition-api'
import nominationsApi from '@/services/api/nominations'

export default function useFilterNominations() {
  const filterStatuses = ref({ horse: [], rider: [] })
  const filterBy = ref('horse')
  const selectedEventId = ref(null)
  const selectedTypeId = ref(null)
  const statistics = ref(null)
  const loadingStats = ref(false)
  const scratching = ref(false)

  const statusOptions = computed(() => {
    const list = filterStatuses.value[filterBy.value] || []
    return list.map(s => ({ id: s.id, name: s.name }))
  })

  async function loadFilterStatuses() {
    try {
      const res = await nominationsApi.getFilterStatuses()
      filterStatuses.value = res.data.data
      const defaults = filterStatuses.value[filterBy.value]
      if (defaults.length > 0 && selectedTypeId.value == null) {
        selectedTypeId.value = defaults[0].id
      }
    } catch (_) {
      filterStatuses.value = { horse: [], rider: [] }
    }
  }

  function setFilterBy(val) {
    filterBy.value = val
    const list = filterStatuses.value[val] || []
    selectedTypeId.value = list.length > 0 ? list[0].id : null
    statistics.value = null
  }

  async function fetchStatistics() {
    if (selectedEventId.value == null || selectedTypeId.value == null) return
    loadingStats.value = true
    try {
      const res = await nominationsApi.getStatisticsByEvent(selectedEventId.value, {
        filter_by: filterBy.value,
        type_id: selectedTypeId.value
      })
      statistics.value = res.data.data
    } catch (_) {
      statistics.value = null
    } finally {
      loadingStats.value = false
    }
  }

  async function scratchAll() {
    if (selectedEventId.value == null || selectedTypeId.value == null) return null
    scratching.value = true
    try {
      const res = await nominationsApi.scratchByStatus(selectedEventId.value, {
        filter_by: filterBy.value,
        type_id: selectedTypeId.value
      })
      statistics.value = null
      return res.data
    } catch (err) {
      throw err
    } finally {
      scratching.value = false
    }
  }

  return {
    filterBy,
    selectedEventId,
    selectedTypeId,
    statistics,
    loadingStats,
    scratching,
    statusOptions,
    loadFilterStatuses,
    setFilterBy,
    fetchStatistics,
    scratchAll
  }
}



// WEBPACK FOOTER //
// ./src/composables/drafts/useFilterNominations.js